module.exports = __webpack_public_path__ + "img/thumb_22.845f2519.jpg";